import {
  LOAD_REPORTS_CHANGE_PAGE,
} from 'constants/ActionTypes';

const loadReportsChangePage = () => ({ type: LOAD_REPORTS_CHANGE_PAGE });
export default loadReportsChangePage;
